<template>
  <div style="min-height: 270px">
    <ic-dialog :show="showCreditDialog">
      <div class="dialog-box">
        <payment @closeCashInModal="closeCashInModal" :request-model="paymentModel" :code="request.code" @showSuccessAlert="showSuccessAlert"></payment>
      </div>
    </ic-dialog>
    <alert :show-alert="successAlert" :has-contract-button="false" :body="succesAlertText" type="success" :title="$t('license.success_title')" :close-btn="$t('license.success_close')" @close="closeSuccessAlert"/>
<!--    <SignDialog :type="type" :show="showDialog" @close="closeDialog" @success="success" :sentType="sentType"/>-->
    <div class="flex-container pb-4">
      <div class="flex-item">
        <h3 class="title">{{ $t('license.fee1_title') }}</h3>
        <LicenseCard :code="'FEE1'" @setFeeCode="setFeeCode" :title="$t('license.fee1_card_title')" :text-body="textBody" :status="payment.FEE1" :price="'10,000'"/>
      </div>
      <div class="flex-item">
        <h3 class="title">{{ $t('license.fee2_title') }}</h3>
        <LicenseCard :code="'FEE2'" @setFeeCode="setFeeCode" :title="$t('license.fee2_card_title')"
                     :text-body="textBody2" :license-date="licenseDate"
                     :status="payment.FEE2" :price="'0'" @click="extendLicense"/>
      </div>
    </div>
    <div class="text-center mt-4">
      <ic-button size="tn" v-if="canSeeBtn" :disabled="!selectedFee1 && !selectedFee2" @click="continueReq">
        <template>
          {{ $t('license.continue') }}
        </template>
      </ic-button>
    </div>
  </div>
</template>

<style scoped lang="scss">
.title {
  font-size: 14px;
  font-weight: 500;
}
.flex-container {
  display: flex;
  flex-direction: row;
  font-size: 30px;
  text-align: center;
}

.flex-item {
  padding: 10px;
  flex: 50%;
}
button {
  background: #0C293A !important;
}

@media (max-width: 1150px) and (min-width: 990px) {
  .flex-container {
    flex-direction: column;
  }
}

@media (max-width: 900px){
  .flex-container {
    flex-direction: column;
  }
}

</style>
<script>
import LicenseCard from "./LicenseCard.vue";
import moment from "moment/moment";
import Payment from '../../components/Payment/index.vue'
import Alert from "../Alert.vue";
export default {
  components: {
    Alert,
    LicenseCard,
    Payment
  },
  data() {
    return {
      selectedFee1: true,
      selectedFee2: false,
      showCreditDialog: false,
      successAlert: false,
      request: {
        amount: null,
        code: null
      }
    }
  },
  computed: {
    licenseDate() {
      const lic = this.$store.getters['user/date'];
      const odate = lic && lic.end_date ? new Date(lic.end_date) : null
      return odate ? moment(odate).format('YYYY-MM-DD') : null
    },
    payment() {
      return this.$store.getters['user/payment'];
    },
    textBody() {
      if (this.payment.FEE1 === 'paid')
        return this.$t('license.fee1_text_paid')
      return this.$t('license.fee1_text_unpaid')
    },
    textBody2() {
      if (this.payment.FEE2 === 'expired')
        return this.$t('license.fee2_text_expired')
      return this.$t('license.fee2_text_active')
    },
    paymentModel() {
      return {
        'amount': this.request.amount
      }
    },
    canSeeBtn() {
      return (this.payment.FEE2 === 'empty' || this.payment.FEE1 === 'empty')
    },
    succesAlertText() {
      if(this.request.code === 'FEE1')
        return this.$t('license.success_fee1')
      if(this.request.code === 'FEE2')
        return this.$t('license.success_fee2', { date: this.licenseDate })
      if(this.request.code === 'FEE3')
        return this.$t('license.success_fee3', { date: this.licenseDate })
      return ''
    }
  },
  methods: {
    showSuccessAlert() {
      this.showCreditDialog = false;
      this.successAlert = true;
    },
    closeSuccessAlert() {
      this.successAlert = false;
    },
    closeCashInModal() {
      this.showCreditDialog = false
    },
    setFeeCode(val1, val2) {
      if (val1 === 'FEE1')
        this.selectedFee1 = val2

      if (val1 === 'FEE2')
        this.selectedFee2 = val2
    },
    continueReq() {
      if(this.selectedFee1 && !this.selectedFee2) {
        this.request.code = "FEE1"
        this.request.amount = 10000
      }
      if(!this.selectedFee1 && this.selectedFee2) {
        this.request.code = "FEE2"
        this.request.amount = 0
      }
      if(this.selectedFee1 && this.selectedFee2) {
        this.request.code = "FEE3"
        this.request.amount = 10000
      }
      this.showCreditDialog = true
    },
    extendLicense() {
      this.request.code = "FEE2"
      this.request.amount = 0
      this.showCreditDialog = true
    }
  }
}
</script>